import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Text } from '@dixa/lib-shared-habla';
import MomentTimezone from 'moment-timezone';
import { Link } from 'react-router-dom';
import { put } from 'redux-saga/effects';
import { notificationActions } from '../../notifications/actions/notification';
import { actions as conversationActions } from '../actions/conversation';
export const { conversationCompleteAcw, conversationExtendAcw } = conversationActions;
const { notificationRemoveById } = notificationActions;
export const acwNotificationType = 'acw';
const extendDuration = 30;
/** Returns the ACW (wrap up time) notification type by conversation id. */
export function getAcwNotificationIdByCsid(csid) {
    return `${acwNotificationType}_${csid}`;
}
/** Gets the conversation id from the ACW notification id. */
export function getCsidFromAcwNotificationId(id) {
    const csid = parseInt(id.replace(`${acwNotificationType}_`, ''));
    return isNaN(csid) ? undefined : csid;
}
function getExpirationMilliseconds(expiration) {
    const isSeconds = ('seconds') in expiration;
    const isTime = ('time') in expiration;
    if (isSeconds && expiration.seconds >= 0) {
        return expiration.seconds * 1000;
    }
    if (isTime && expiration.time) {
        return MomentTimezone(expiration.time).diff(MomentTimezone());
    }
    return null;
}
export function getAcwNotification({ csid, text = 'You are now in wrap-up time in conversation', expiration, }) {
    const notificationId = getAcwNotificationIdByCsid(csid);
    const expirationMilliseconds = getExpirationMilliseconds(expiration);
    const isEndWrapUpBlocked = expirationMilliseconds === null;
    return {
        id: notificationId,
        type: acwNotificationType,
        title: `Wrap-up time`,
        text: (_jsxs(Text.Paragraph, { children: [text, " ", _jsxs(Link, Object.assign({ to: `/conversation/${csid}` }, { children: ["#", csid] }))] })),
        icon: 'clock-one',
        time: expirationMilliseconds !== null && expirationMilliseconds !== void 0 ? expirationMilliseconds : undefined,
        closeAction: function* () {
            yield put(notificationRemoveById({ id: notificationId }));
            if (!isEndWrapUpBlocked) {
                yield put(conversationCompleteAcw({ csid }));
            }
        },
        mainAction: {
            navigate: `/conversation/${csid}`,
        },
        banner: isEndWrapUpBlocked
            ? {
                description: (_jsx("span", { children: "Wrap-up time can only end when the missing required attributes are filled in." })),
                variant: 'warning',
            }
            : undefined,
        leftAction: {
            text: `Extend with ${MomentTimezone(extendDuration * 1000)
                .utc()
                .format('mm:ss')}`,
            hidden: isEndWrapUpBlocked,
            action: function* () {
                try {
                    if (!isEndWrapUpBlocked) {
                        yield put(conversationExtendAcw({ csid, duration: extendDuration }));
                    }
                }
                catch (exception) {
                    console.warn(exception);
                }
            },
        },
        rightAction: {
            text: 'End',
            hidden: isEndWrapUpBlocked,
            action: function* () {
                yield put(conversationCompleteAcw({ csid }));
                yield put(notificationRemoveById({
                    id: notificationId,
                }));
            },
        },
    };
}
